import React from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import compose from 'recompose/compose'
import pure from 'recompose/pure'

const styleSheet = theme => ({
    wrapper: {
        width: '100%',
        height: '100%',
        position: 'relative',
        cursor: 'pointer',
        pointerEvents: 'all',
        zIndex: 200,
    },
    hidden: {
        display: 'none',
    },
    infoSize: {
        '& > div > div': {
            width: '24px !important',
            height: '24px !important',
            filter: 'drop-shadow( 0px 4px 2px rgba(0, 0, 0, .8))',
        },
    },
    infoIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        color: theme.palette.common.white,
        fontSize: 28,
    },
    border: {
        border: '1.3px solid #fff',
        width: 'calc(100% + 2px)',
        height: 'calc(100% + 2px)',
        borderRadius: '50%',
        position: 'absolute',
        boxSizing: 'border-box',
        top: -1,
        left: -1,
        animationDuration: `1.1s`,
        animationName: 'infoButtonBorderPulse',
        animationIterationCount: 'infinite',
        pointerEvents: 'none',
    },
    infoStyle: {
        width: '8px',
        color: '#FFFFFF',
        fontFamily: 'CircularStd',
        fontSize: '27.72px',
        fontWeight: 'bold',
        letterSpacing: '0',
        lineHeight: '35px',
        textAlign: 'center',
    },
    '@keyframes infoButtonBorderPulse': {
        '0%': {
            transform: 'scale(1)',
            opacity: '1',
        },
        '100%': {
            transform: 'scale(1.6)',
            opacity: '0',
        },
    },
})

const style = injectSheet(styleSheet)

const StopInfoButton = ({ classes, children, onClick, buttonClassName, hideInfoButton, audioIsPlaying }) => (
    <div className={classNames({ [classes.hidden]: hideInfoButton }, classes.infoSize)}>
        <span onClick={onClick} className={classes.infoStyle} alt={'info'}>
            i
        </span>
    </div>
)

export default compose(style, pure)(StopInfoButton)
